import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface YahooIconProps extends SvgIconProps {}

export const YahooIcon = ({
  style,
  ...iconProps
}: YahooIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="29.999"
      height="27.845"
      viewBox="0 0 29.999 27.845"
    >
      <g id="Layer_1" data-name="Layer 1">
        <path
          d="M112.8,0h6.464V.166L113.63,13.922H107Z"
          transform="translate(-89.266)"
          fill="#6000d2"
          fillRule="evenodd"
        />
        <path
          d="M0,41H5.967l3.481,8.619h.166L12.928,41h5.8Q14.338,51.525,9.945,62.049h-5.8l2.32-5.967Z"
          transform="translate(0 -34.205)"
          fill="#6000d2"
          fillRule="evenodd"
        />
        <path
          d="M99.341,91.945c5.138-.31,5.829,6.083,1.823,7.127C95.7,100.5,95.76,93.971,99.341,91.945Z"
          transform="translate(-80.778 -76.697)"
          fill="#6000d2"
          fillRule="evenodd"
        />
      </g>
    </SvgIcon>
  );
};
